/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Created_WarningInputs */



/**
* | output |
* | --- |
* | "Copy it now. We won't show it again." |
*
* @param {Profile_Security_User_Api_Key_Created_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_created_warning = /** @type {((inputs?: Profile_Security_User_Api_Key_Created_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Created_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopiere ihn jetzt. Wir zeigen ihn nicht wieder an.")
	return /** @type {LocalizedString} */ ("Copy it now. We won't show it again.")
});